export default "__VITE_ASSET__DyR3NzCq__"